<template>
  <div>
    <a-modal
      width="540px"
      title="应用价值追溯"
      :visible="visible"
      :ok-button-props="{ props: { loading: loading } }"
      @cancel="onClose"
      @ok="onOk"
    >
      <a-form-model :form="formData" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :model="formData">
        <a-row :gutter="24">
          <a-form-model-item label="是否需要追溯" prop="isValueRetrospect">
            <a-switch v-model="formData.isValueRetrospect" @change="onChangeIsValueRetrospect" />
          </a-form-model-item>
          <a-form-model-item v-if="formData.isValueRetrospect" label="追溯类型" prop="retrospectType">
            <a-checkbox-group v-model="formData.retrospectType">
              <a-checkbox :value="1" disabled> 应用追溯</a-checkbox>
              <a-checkbox :value="2"> 价值追溯</a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { updateBusinessRequirementSimpleField } from '@/api/business/requirement';

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        isValueRetrospect: false,
        retrospectType: []
      }
    };
  },
  computed: {
  },
  methods: {
    onOpen(retrospectTypes) {
      if (!retrospectTypes) {
        this.formData = {
          isValueRetrospect: false,
          retrospectType: []
        };
      } else {
        this.formData = {
          isValueRetrospect: true,
          retrospectType: JSON.parse(JSON.stringify(retrospectTypes || []))
        };
      }
      this.visible = true;
    },

    onChangeIsValueRetrospect(checked) {
      if (checked) {
        console.log(this.formData.retrospectType);
        if (!this.formData.retrospectType || this.formData.retrospectType.length === 0) {
          this.$set(this.formData, 'retrospectType', [1]);
        }
      } else {
        this.$set(this.formData, 'retrospectType', []);
      }
    },

    onClose() {
      this.visible = false;
    },
    onOk() {
      this.loading = true;
      updateBusinessRequirementSimpleField({ id: this.dataSource.id, fields: { retrospectType: JSON.stringify(this.formData.retrospectType) }})
        .then(() => {
          this.$emit('saveOk');
          this.$message.success('保存成功');
          this.onClose();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}
</style>
